import { Config } from "../../configurations/config";

export const ItemRequisitionAPI = {
  //-----------------------------------Listing Item Requisition ------------------------//
  GetItemRequisitionPagination: `${Config.server_url}${Config.api_prefix}/ItemRequisition`,
  GetItemRequisitionStatusTypes: `${Config.server_url}${Config.api_prefix}/ItemRequisition/ItemRequisitionStatusTypes`,

  //-----------------------------------Create/View/Delete Item Requisition Layout ------------------------//
  GetReqPriorityList: `${Config.server_url}${Config.api_prefix}/ItemRequisition/GetPriorityStatusTypes`,
  GetItemRequisitionbyID: `${Config.server_url}${Config.api_prefix}/ItemRequisition`,
  PostItemRequisition: `${Config.server_url}${Config.api_prefix}/ItemRequisition/`,
  DeleteItemRequisitionbyId: `${Config.server_url}${Config.api_prefix}/ItemRequisition`,
  PutItemRequisition: `${Config.server_url}${Config.api_prefix}/ItemRequisition`,

  //-----------------------------------Kashif Flows Layout ------------------------//
  GetEmployeeInfo: `${Config.server_url}${Config.api_prefix}/Leave/GetMyPersonalInfoAndEmergencyContact`,
  GetRequestTypes: `${Config.server_url}${Config.api_prefix}/ItemRequisition/GetRequestTypes`,
  GetCategories: `${Config.server_url}${Config.api_prefix}/ItemRequisition/Category/Active`,
  GetAdminSupportApprovalTypes: `${Config.server_url}${Config.api_prefix}/ItemRequisition/GetAdminSupportApprovalTypes`,
  GetVendorByCategoryId: `${Config.server_url}${Config.api_prefix}/ItemRequisition/Category`,
  GetTagAssetByCategoryId: `${Config.server_url}${Config.api_prefix}/ItemRequisition/Category`,
  GetItemRequisitionRequestDetailById: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  GetVendorQuotationsList: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  PostVendorQuotations: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  PutVendorQuotations: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  DeleteVendorQuotation: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  GetTagAssetsList: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  PostTagAssets: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  PutTagAssets: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeeRequests`,
  DeleteTagAsset: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeeRequests`,
  GetRelevantDepartment: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  updateRelevantDepartment: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests`,
  ExportToExcel: `${Config.server_url}${Config.api_prefix}/ItemRequisition/EmployeesRequests/TagAssets/ExportToExcel`,

  /*--------------Uzma Flow -----*/
  GetReceivingSection: `${Config.server_url}${Config.api_prefix}/ItemRequisition`,
  GetItemReceivingTypes: `${Config.server_url}${Config.api_prefix}/ItemRequisition/ItemReceivingTypes`,

  /*--------------CM Flow -----*/

  GetApproval: `${Config.server_url}${Config.api_prefix}/ItemRequisition`,
  PostApproval: `${Config.server_url}${Config.api_prefix}/ItemRequisition`,
};
